import { render, staticRenderFns } from "./UpdateForm4.vue?vue&type=template&id=01700504"
import script from "./UpdateForm4.vue?vue&type=script&lang=js"
export * from "./UpdateForm4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports